<!-- svelte-ignore a11y-missing-attribute -->
<div class="top-background" style="background-image:url(images/backgrounds/collaborations.jpg);">
    <h1 class="page-title">Collaborations</h1>
    <!-- Credit to the photographer (not required but still giving it) -->
    <div class="credit">
        Photo by <a href="https://unsplash.com/@d_mccullough?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">Daniel McCullough</a>
    </div>
</div>

<!-- svelte-ignore a11y-missing-attribute -->

<!-- Funding options -->
<section id="funding">

    <div class="heading">
        <h1>Funding</h1>
        <p>Regardless of the size of your project, the LCML has a number of funding mechanisms that can be leveraged to maximize your investment. These funding mechanisms ensure that you get access to highly qualified researchers and state-of-the-art technology for your industry projects. Contact us to find out more.</p>
    </div>

    <div class="content">
        <!-- Funding option cards -->
        <ul class="funding-options">

            <!-- NSERC Strategic Partnership Grants -->
            <li>
                <h3>NSERC Strategic Partnership Grants</h3>
                <div class="details">
                    <div class="label">Minimum Partner Investment:</div>
                    <div class="icon-wrapper">
                        <img class="icon" src="images/icons/cost.png">
                        <h5 class="cost-text">50,000</h5>
                    </div>
                    <div class="label">Project Duration:</div>
                    <div class="icon-wrapper">
                        <img class="icon" src="images/icons/duration.png">
                        <img class="icon" src="images/icons/duration.png">
                        <img class="icon" src="images/icons/duration.png">
                        <img class="icon" src="images/icons/duration.png">
                    </div>
                    <div class="label">Total Project Cost:</div>
                    <div class="icon-wrapper">
                        <img class="icon" src="images/icons/cost.png">
                        <img class="icon" src="images/icons/cost.png">
                        <img class="icon" src="images/icons/cost.png">
                        <img class="icon" src="images/icons/cost.png">
                    </div>
                    <a class="action-button" href="http://www.nserc-crsng.gc.ca/Professors-Professeurs/RPP-PP/SPG-SPS_eng.asp" target="_blank">View Details</a>
                </div>
            </li>

            <!-- NSERC Collaborative Research & Development Grants -->
            <li>
                <h3>NSERC Collaborative Research & Development Grants</h3>
                <div class="details">
                    <div class="label">Minimum Partner Investment:</div>
                    <div class="icon-wrapper">
                        <img class="icon" src="images/icons/cost.png">
                        <h5 class="cost-text">25,000</h5>
                    </div>
                    <div class="label">Project Duration:</div>
                    <div class="icon-wrapper">
                        <img class="icon" src="images/icons/duration.png">
                        <img class="icon" src="images/icons/duration.png">
                        <img class="icon" src="images/icons/duration.png">
                        <img class="icon" src="images/icons/duration-inactive.png">
                    </div>
                    <div class="label">Total Project Cost:</div>
                    <div class="icon-wrapper">
                        <img class="icon" src="images/icons/cost.png">
                        <img class="icon" src="images/icons/cost.png">
                        <img class="icon" src="images/icons/cost.png">
                        <img class="icon" src="images/icons/cost-inactive.png">
                    </div>
                    <a class="action-button" href="http://www.nserc-crsng.gc.ca/Professors-Professeurs/RPP-PP/CRD-RDC_eng.asp" target="_blank">View Details</a>
                </div>
            </li>

            <!-- Mitacs Accelerate -->
            <li>
                <h3>Mitacs Accelerate</h3>
                <div class="details">
                    <div class="label">Minimum Partner Investment:</div>
                    <div class="icon-wrapper">
                        <img class="icon" src="images/icons/cost.png">
                        <h5 class="cost-text">7,500</h5>
                    </div>
                    <div class="label">Project Duration:</div>
                    <div class="icon-wrapper">
                        <img class="icon" src="images/icons/duration.png">
                        <img class="icon" src="images/icons/duration.png">
                        <img class="icon" src="images/icons/duration-inactive.png">
                        <img class="icon" src="images/icons/duration-inactive.png">
                    </div>
                    <div class="label">Total Project Cost:</div>
                    <div class="icon-wrapper">
                        <img class="icon" src="images/icons/cost.png">
                        <img class="icon" src="images/icons/cost.png">
                        <img class="icon" src="images/icons/cost-inactive.png">
                        <img class="icon" src="images/icons/cost-inactive.png">
                    </div>
                    <a class="action-button" href="https://www.mitacs.ca/en/programs/accelerate" target="_blank">View Details</a>
                </div>
            </li>

            <!-- NSERC Engage Grants -->
            <li>
                <h3>NSERC Engage Grants</h3>
                <div class="details">
                    <div class="label">Minimum Partner Investment:</div>
                    <div class="icon-wrapper">
                        <img class="icon" src="images/icons/cost.png">
                        <h5 class="cost-text">In Kind Support</h5>
                    </div>
                    <div class="label">Project Duration:</div>
                    <div class="icon-wrapper">
                        <img class="icon" src="images/icons/duration.png">
                        <img class="icon" src="images/icons/duration-inactive.png">
                        <img class="icon" src="images/icons/duration-inactive.png">
                        <img class="icon" src="images/icons/duration-inactive.png">
                    </div>
                    <div class="label">Total Project Cost:</div>
                    <div class="icon-wrapper">
                        <img class="icon" src="images/icons/cost.png">
                        <img class="icon" src="images/icons/cost-inactive.png">
                        <img class="icon" src="images/icons/cost-inactive.png">
                        <img class="icon" src="images/icons/cost-inactive.png">
                    </div>
                    <a class="action-button" href="http://www.nserc-crsng.gc.ca/Professors-Professeurs/RPP-PP/Engage-Engagement_eng.asp" target="_blank">View Details</a>
                </div>
            </li>
        </ul>
    </div>

</section>

<!-- Collaboration organizations -->
<section id="collaborations">

    <div class="content">
        <h1>Our Collaborations</h1>

        <!-- Government Organizations -->
        <div class="organization-category">
            <h3>Government Organizations</h3>
            <div class="image-container">
                <img src="images/collaborations/government-organizations/1.png" alt="">
                <img src="images/collaborations/government-organizations/2.png" alt="">
                <img src="images/collaborations/government-organizations/3.png" alt="">
                <img src="images/collaborations/government-organizations/4.png" alt="">
                <img src="images/collaborations/government-organizations/5.png" alt="">
                <img src="images/collaborations/government-organizations/6.png" alt="">
                <img src="images/collaborations/government-organizations/7.png" alt="">
            </div>
        </div>

        <!-- Granting Agencies -->
        <div class="organization-category">
            <h3>Granting Agencies</h3>
            <div class="image-container">
                <img src="images/collaborations/granting-agencies/1.png" alt="">
                <img src="images/collaborations/granting-agencies/2.png" alt="">
                <img src="images/collaborations/granting-agencies/3.png" alt="">
            </div>
        </div>

        <!-- Industry Partners -->
        <div class="organization-category">
            <h3>Industry Partners</h3>
            <div class="image-container">
                <img src="images/collaborations/industry-partners/1.png" alt="">
                <img src="images/collaborations/industry-partners/2.png" alt="">
                <img src="images/collaborations/industry-partners/3.png" alt="">
                <img src="images/collaborations/industry-partners/4.png" alt="">
                <img src="images/collaborations/industry-partners/5.png" alt="">
                <img src="images/collaborations/industry-partners/6.png" alt="">
                <img src="images/collaborations/industry-partners/7.png" alt="">
                <img src="images/collaborations/industry-partners/8.png" alt="">
                <img src="images/collaborations/industry-partners/9.png" alt="">
                <img src="images/collaborations/industry-partners/10.png" alt="">
                <img src="images/collaborations/industry-partners/11.png" alt="">
                <img src="images/collaborations/industry-partners/12.png" alt="">
                <img src="images/collaborations/industry-partners/13.png" alt="">
                <img src="images/collaborations/industry-partners/14.png" alt="">
                <img src="images/collaborations/industry-partners/15.png" alt="">
                <img src="images/collaborations/industry-partners/16.png" alt="">
            </div>
        </div>

        <!-- University Partners -->
        <div class="organization-category">
            <h3>University Partners</h3>
            <div class="image-container">
                <img src="images/collaborations/university-partners/1.png" alt="">
                <img src="images/collaborations/university-partners/2.png" alt="">
            </div>
        </div>
    </div>
    
</section>




<style lang="sass">

@import "../consts.sass"
@include page-header()
@include action-button()

.heading
    background-color: #f4f4f4

.content, .heading
    padding: 2em
    box-sizing: border-box

    @media only screen and (min-width: 1200px) 
        padding-right: 10vw
        padding-left: 10vw

.content
    ul.funding-options
        list-style-type: none
        display: flex
        flex-direction: row
        flex-flow: wrap
        justify-content: space-between
        margin: 0
        margin-top: 2em

        li
            display: flex
            flex-direction: column
            justify-content: space-between
            flex: 1 1 auto
            width: 20em
            margin-bottom: 2.8em
            box-sizing: border-box
            padding: 0 4em

            &:not(:first-child)
                border-left: 1px solid $color_grey

            .details
                display: flex
                flex-direction: column
            
                .label
                    background-color: transparent
                    color: $color_ink

                .icon-wrapper
                    display: flex
                    flex-direction: row
                    align-items: center
                    margin-top: 0.4em
                    margin-bottom: 1.2em

                    .icon
                        width: 1.9em

                        &:not(:last-child)
                            margin-right: 0.5em

                    .cost-text
                        font-weight: bold
                        font-size: 1.5em
                        font-family: sans-serif
                        margin: 0

    .organization-category
        border-left: 6px solid $color_secondary
        border-radius: 0.1em
        padding: 0.3em 1.8em
        box-sizing: border-box
        margin: 3em 0
        background-color: #f3f5f5

        .image-container
            display: flex
            flex-direction: row
            flex-flow: wrap
            margin-top: 2em

            img
                height: 6em
                margin-right: 3em
                margin-bottom: 2.5em
                border-radius: 0.2em

</style>